export const getPriceWithoutTax = (price, taxPrecentage) => {
  return Math.round(price / ((100 + taxPrecentage) / 100));
};

// export const getPriceWithTax = (price, taxPrecentage) => {
//   return price * ((100 + taxPrecentage) / 100);
// };

export const getTaxFromPrice = (price, taxPrecentage) => {
  return price - price / ((100 + taxPrecentage) / 100);
};



// WEBPACK FOOTER //
// ./src/helpers/priceCalculationHelper.js